import { SVGProps } from "react";

const SmallErrorIcon = ({ className, ...props }: SVGProps<SVGSVGElement> & { className?: string }) => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    {...props}
  >
    <path
      d="M6.99998 0.333374C3.31998 0.333374 0.333313 3.32004 0.333313 7.00004C0.333313 10.68 3.31998 13.6667 6.99998 13.6667C10.68 13.6667 13.6666 10.68 13.6666 7.00004C13.6666 3.32004 10.68 0.333374 6.99998 0.333374ZM7.66665 10.3334H6.33331V9.00004H7.66665V10.3334ZM7.66665 7.66671H6.33331V3.66671H7.66665V7.66671Z"
      fill="#E70000"
    />
  </svg>
);

export default SmallErrorIcon;
